const delayAction = window.requestIdleCallback || function (cb) {
  const start = Date.now();
  return setTimeout(function () {
    cb({
      didTimeout: false,
      timeRemaining: function () {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
};

const cancelAction = window.cancelIdleCallback || function (id) {
  clearTimeout(id);
};

const delayAnimationAction = window.requestIdleCallback || function (cb) {
  const start = Date.now();
  return requestAnimationFrame(function () {
    cb({
      didTimeout: false,
      timeRemaining: function () {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
};

const cancelAnimationAction = window.cancelIdleCallback || function (id) {
  cancelAnimationFrame(id);
};

export { delayAction, cancelAction, delayAnimationAction, cancelAnimationAction };